import * as Schema from "effect/Schema";

import { NonNegativeInt } from "./baseSchemas.ts";

/**
 * Whole-machine capacity for one AFAR Environment, independent of the Environment Service's own
 * process diagnostics. Diagnostics answer "what is AFAR doing to this machine"; this answers
 * "how much of this machine is left", which is the only question load balancing asks.
 *
 * `cpuUtilization` is null when a sample could not be taken, never 0: a machine whose CPU is
 * unknown must not read as idle and win every placement.
 */
export const HostResourcesSnapshot = Schema.Struct({
  sampledAt: NonNegativeInt,
  cpuUtilization: Schema.NullOr(Schema.Number.check(Schema.isBetween({ minimum: 0, maximum: 1 }))),
  cpuCount: NonNegativeInt,
  availableMemoryBytes: NonNegativeInt,
  totalMemoryBytes: NonNegativeInt,
});
export type HostResourcesSnapshot = typeof HostResourcesSnapshot.Type;
